// This file can be replaced during build by using the `fileReplacements` array.

// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
export const environment = {
  production: false,
  hmr: false,
  qa: false,
  dev: false,
  local: true,
  pubNubChannelPrefix: 'dev_',
  staging: false,
  s3_bucket_url: 'https://volmits3static.s3.ap-south-1.amazonaws.com/',
  // appUrl: 'http://localhost:8000/',
  appUrl: 'https://backend-exam.msde.in/',
  analyzeUrl: 'http://13.232.55.137/',
  bucket: {
    bucket_name: 'volmits3static',
    bucket_prefix: 'kinesis',
    region: 'ap-south-1',
    accessKeyId: 'AKIA57VDLWGLOCD27LUH',
    secretAccessKey: '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',
  },
  aws: {
    region: 'ap-south-1',
    accessKeyId: 'AKIA57VDLWGLDSW6Z3P4',
    secretAccessKey: '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',
    channelName: 'volmint',
    sessionToken: null,
    ingestMedia: false,
    sendVideo: true,
    sendAudio: true,
    openDataChannel: false,
    useTrickleICE: true,
    natTraversalDisabled: false,
    forceTURN: false,
    forceSTUN: false,
    widescreen: true,
  },
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
